import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.userProfileSuccess"],
  action => action
);
